import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppThunk } from '../index'
export interface BreadcrumbState {
  title?: string,
  menuName?: string
}

const initialState: BreadcrumbState = {
  title: '',
  menuName: ''
}

export const breadcrumbSlice = createSlice({
  name: 'breadcrumb',
  initialState,
  reducers: {
    setBreadcrumbState(state, action: PayloadAction<BreadcrumbState>) {
      state.title = action.payload.title
      state.menuName = action.payload.menuName
    }
  }
})
export const getBreadcrumbAsync = (): AppThunk => async (dispatch, getState) => {
  try {
    return Promise.resolve(true)
  } catch (error) {
    return Promise.reject(false)
  }
}

export default breadcrumbSlice.reducer

export const { setBreadcrumbState } = breadcrumbSlice.actions
